import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import authentication from '../../image/authentication.png';
import firebaseServices from '../../image/firebase-services.png';
import firebase from '../../image/firebase.jpg';
import './Blogs.css';
const Blogs = () => {
    return (
        <div className='blogs'>
            <Container className='py-5'>
                <h2 className="title my-5">Blogs</h2>
                <Row xs={1} md={2} lg={3} className="g-4">
                    <Col>
                        <Card>
                            <Card.Img variant="top" src={authentication} />
                            <Card.Body>
                                <Card.Title className=' my-3 '>
                                    <h3>Difference between Authentication and Authorization ?</h3>
                                </Card.Title>
                                <Card.Text>
                                    Authentication means verifying your own identity, while authorization means acknowledging access to the system. In simple terms, authentication is the process of validating who you are, while authorization is the process of verifying what you hold access to. 
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <Card.Img variant="top" src={firebase} />
                            <Card.Body>
                                <Card.Title className=' my-3 '>
                                    <h3>Why are you using firebase ?</h3>
                                </Card.Title> 
                                <Card.Text>
                                    <ol>
                                        <li>
                                            <strong>Cloud Messaging :</strong> It saves and receive communications in a further solid way across platforms
                                        </li>
                                        <li>
                                            <strong>Authentication :</strong> It holds a lot less friction with cracked up authentication
                                        </li>
                                        <li>
                                            <strong>Hosting :</strong> Deliver web content quickly 
                                        </li>
                                        <li>
                                            <strong>Remote :</strong> Configuration customizes your app on the go 
                                        </li>
                                        <li>
                                            <strong>Test Lab :</strong> Test in the lab rather than on your users
                                        </li>
                                        <li>
                                            <strong>Crash Reporting :</strong> It keeps your app fast
                                        </li>
                                        <li>
                                            <strong>Realtime Database :</strong> It stores and sync app data in realtime
                                        </li>
                                        <li>
                                            <strong>Storage File :</strong> It make storing easier
                                        </li>
                                    </ol>
                                </Card.Text> 
                            </Card.Body>
                        </Card>
                    </Col>
                    
                    <Col>
                        <Card>
                            <Card.Img variant="top" src={firebaseServices} />
                            <Card.Body>
                                <Card.Title className=' my-3 '>
                                    <h3>
                                        What other services does firebase give other than authentication? 
                                    </h3>    
                                </Card.Title> 
                                <Card.Text>
                                    Other than authentication firebase provides - Cloud FireStore , Cloud Functions , Hosting ,Cloud Storage , Google Analytics , Predictions , Cloud Messaging, Dynamic Links , Remote Config
                                </Card.Text> 
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};


export default Blogs;
